<template>
    <DButtonDropdown
        :class="'contact-list-dropdown'"
        icon="dots-horizontal"
    >
        <DDropdownItem
            v-if="availableActions.activate"
            icon="check"
            @click="clickActivate(item)"
        >
            {{ __('customers.contracts.set_active') }}
        </DDropdownItem>
        <Link
            v-if="availableActions.edit"
            :href="editCustomerContractLink(item)"
        >
            <DDropdownItem
                icon="pencil"
            >
                {{ __('customers.contracts.edit') }}
            </DDropdownItem>
        </Link>
        <DDropdownItem
            v-if="availableActions.addAddon"
            icon="plus"
            @click="clickAddAddon(item)"
        >
            {{ __('customers.contracts.add_addon') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.cancel"
            icon="close-octagon"
            @click="clickCancel(item)"
        >
            {{ __('customers.contracts.cancel') }}
        </DDropdownItem>
        <DDropdownSpacer />
        <DDropdownItem
            v-if="availableActions.terminate"
            icon="close-octagon"
            :disabled="isInLoadingState"
            @click="clickTerminate(item)"
        >
            {{ __('customers.contracts.terminate') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.terminateSilently"
            icon="close-octagon-outline"
            :disabled="isInLoadingState"
            @click="clickTerminateSilently(item)"
        >
            {{ __('customers.contracts.terminate_silently') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.sendAuthCode"
            icon="send"
            :disabled="isInLoadingState"
            @click="clickSendAuthCode(item)"
        >
            {{ __('customers.contracts.send_auth_code.send_auth_code') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.cancelTerminate"
            icon="close-octagon"
            :disabled="isInLoadingState"
            @click="clickCancelTerminate(item)"
        >
            {{ __('customers.contracts.cancel_terminations') }}
        </DDropdownItem>
        <DDropdownSpacer />
        <DDropdownItem
            v-if="availableActions.applyMoneyBackGuarantee"
            icon="cash"
            :disabled="isInLoadingState"
            @click="clickApplyMoneyBackGuarantee(item)"
        >
            {{ __('customers.contracts.apply_money_back_guarantee.name') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.withdrawal"
            icon="backup-restore"
            :disabled="isInLoadingState"
            @click="clickWithdrawal(item)"
        >
            {{ __('customers.contracts.withdrawal_contract.name') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.moveContract"
            icon="shuffle-variant"
            :disabled="isInLoadingState"
            @click="clickMoveContract(item)"
        >
            {{ __('customers.contracts.move_contract.move_contract') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.unsuspend"
            icon="keyboard-return"
            :disabled="isInLoadingState"
            @click="clickUnsuspend(item)"
        >
            {{ __('customers.contracts.unsuspend_contract.name') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.release"
            icon="play-box-outline"
            :disabled="isInLoadingState"
            @click="clickRelease(item)"
        >
            {{ __('customers.contracts.release.name') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.releaseTree"
            icon="play-box-outline"
            :disabled="isInLoadingState"
            @click="clickReleaseTree(item)"
        >
            {{ __('customers.contracts.release_tree.name') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.delete"
            icon="trash-can-outline"
            :disabled="isInLoadingState"
            @click="clickDelete(item)"
        >
            {{ __('customers.contracts.delete.name') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.deleteTree"
            icon="trash-can-outline"
            :disabled="isInLoadingState"
            @click="clickDeleteTree(item)"
        >
            {{ __('customers.contracts.delete_tree.name') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="availableActions.restore"
            icon="delete-restore"
            :disabled="isInLoadingState"
            @click="clickRestore(item)"
        >
            {{ __('customers.contracts.restore_contract.button') }}
        </DDropdownItem>
        <DDropdownItem
            v-if="hasActions === false"
            :disabled="true"
        >
            {{ __('customers.contracts.no_actions') }}
        </DDropdownItem>
    </DButtonDropdown>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ContractListItemDropdown',
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            }
        },
        parentContractStatus: {
            type: String,
            default: () => {
                return null
            }
        }
    },
    emits: [
        'clickActivate', 'clickCancel', 'clickTerminate', 'clickTerminateSilently',
        'clickSendAuthCode', 'clickCancelTerminate', 'clickApplyMoneyBackGuarantee', 'clickWithdrawal',
        'clickMoveContract', 'clickUnsuspend', 'clickRelease', 'clickReleaseTree',
        'clickDelete', 'clickDeleteTree', 'clickRestore', 'clickAddAddon'
    ],
    computed: {
        availableActions () {
            return {
                activate: this.item.status === 'wait_for_activation' &&
                    this.item.status !== 'draft' &&
                    this.userPermissions.includes('contract.pending'),
                applyMoneyBackGuarantee: !this.item.termination &&
                    !this.item.one_time &&
                    this.item.status !== 'draft' &&
                    this.item.status !== 'scheduled' &&
                    this.userPermissions.includes('contract.terminate') &&
                    this.item.status !== 'cancelled' &&
                    this.item.manual_termination_disallowed !== true &&
                    this.item.is_ff_child_contract === false,
                cancel: this.item.status !== 'cancelled' &&
                    this.item.one_time &&
                    this.item.status !== 'draft' &&
                    this.item.billed_until_date === null &&
                    this.userPermissions.includes('contract.edit') &&
                    this.item.is_ff_child_contract === false,
                cancelTerminate: this.item.termination &&
                    !this.item.one_time &&
                    this.item.status !== 'draft' &&
                    this.userPermissions.includes('contract.terminate') &&
                    this.item.active_termination_status !== 'done' &&
                    this.item.status !== 'cancelled' &&
                    this.item.is_ff_child_contract === false &&
                    this.item.termination_cancellation_possible === true,
                delete: this.userPermissions.includes('contract.edit') &&
                    this.item.is_pre_live &&
                    (this.item.children.length === 0 || this.item.is_ff_contract === true) &&
                    this.item.is_ff_child_contract === false,
                deleteTree: this.userPermissions.includes('contract.edit') &&
                    this.item.is_pre_live &&
                    this.item.children.length > 0 &&
                    this.item.is_ff_contract === false &&
                    this.item.is_ff_child_contract === false,
                edit: this.item.status !== 'terminated' &&
                    this.item.status !== 'cancelled' &&
                    this.userPermissions.includes('contract.edit'),
                moveContract: this.item.parent_contract_id === null &&
                    this.userPermissions.includes('contract.edit') &&
                    this.item.status !== 'cancelled' &&
                    this.item.is_contract_movable &&
                    this.item.is_ff_child_contract === false,
                release: this.userPermissions.includes('contract.edit') &&
                    this.item.status === 'draft' &&
                    this.item.is_ff_child_contract === false &&
                    this.parentContractStatus !== 'draft',
                releaseTree: this.userPermissions.includes('contract.edit') &&
                    this.item.status === 'draft' &&
                    this.contractHasChildInDraftStatus(this.item) === true &&
                    this.item.is_ff_contract === false &&
                    this.item.is_ff_child_contract === false,
                restore: this.userPermissions.includes('contract.restore') &&
                    this.item.is_restorable &&
                    this.item.is_ff_child_contract === false,
                sendAuthCode: this.userPermissions.includes('contract.edit') &&
                    this.item.supports_send_auth_code === true &&
                    this.item.fulfillment_account_id !== null &&
                    this.item.active_termination_status !== 'done',
                terminate: !this.item.termination &&
                    !this.item.one_time &&
                    this.userPermissions.includes('contract.terminate') &&
                    this.item.status !== 'cancelled' &&
                    this.item.allowed_to_terminate &&
                    this.item.is_ff_child_contract === false,
                terminateSilently: !this.item.one_time &&
                    this.item.status !== 'draft' &&
                    this.item.status !== 'scheduled' &&
                    this.userPermissions.includes('contract.terminate_silently') &&
                    this.item.active_termination_status !== 'done' &&
                    this.item.status !== 'cancelled' &&
                    this.item.allowed_to_terminate &&
                    this.item.is_ff_child_contract === false &&
                    this.item.silent_termination_supported,
                unsuspend: !this.item.one_time &&
                    this.item.status !== 'draft' &&
                    this.userPermissions.includes('contract.edit') &&
                    this.item.status === 'suspended' &&
                    this.item.is_ff_child_contract === false,
                withdrawal: !this.item.termination &&
                    this.item.status !== 'draft' &&
                    this.item.status !== 'scheduled' &&
                    !this.item.one_time &&
                    this.userPermissions.includes('contract.terminate') &&
                    this.item.status !== 'cancelled' &&
                    this.item.manual_termination_disallowed !== true &&
                    this.item.is_ff_child_contract === false,
                addAddon: !this.item.is_addon &&
                    this.userPermissions.includes('contract.edit') &&
                    this.item.status !== 'terminated' &&
                    (this.item.end_date === null || moment(this.item.end_date).isAfter(moment().startOf('day'))) &&
                    this.item.has_possible_addons === true
            }
        },
        hasActions () {
            return Object.values(this.availableActions).some((enabled) => enabled)
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        clickActivate (item) {
            this.$emit('clickActivate', item)
        },
        clickCancel (item) {
            this.$emit('clickCancel', item)
        },
        clickTerminate (item) {
            this.$emit('clickTerminate', item)
        },
        clickTerminateSilently (item) {
            this.$emit('clickTerminateSilently', item)
        },
        clickSendAuthCode (item) {
            this.$emit('clickSendAuthCode', item)
        },
        clickCancelTerminate (item) {
            this.$emit('clickCancelTerminate', item)
        },
        clickApplyMoneyBackGuarantee (item) {
            this.$emit('clickApplyMoneyBackGuarantee', item)
        },
        clickWithdrawal (item) {
            this.$emit('clickWithdrawal', item)
        },
        clickMoveContract (item) {
            this.$emit('clickMoveContract', item)
        },
        clickUnsuspend (item) {
            this.$emit('clickUnsuspend', item)
        },
        clickRelease (item) {
            this.$emit('clickRelease', item)
        },
        clickReleaseTree (item) {
            this.$emit('clickReleaseTree', item)
        },
        clickDelete (item) {
            this.$emit('clickDelete', item)
        },
        clickDeleteTree (item) {
            this.$emit('clickDeleteTree', item)
        },
        clickRestore (item) {
            this.$emit('clickRestore', item)
        },
        clickAddAddon (item) {
            this.$emit('clickAddAddon', item)
        },
        contractHasChildInDraftStatus (item) {
            if (item.children.length > 0) {
                for (const child of item.children) {
                    if (child.status === 'draft') {
                        return true
                    }

                    const match = this.contractHasChildInDraftStatus(child)

                    if (match !== false) {
                        return match
                    }
                }
            }

            return false
        },
        editCustomerContractLink (contract) {
            return this.$route('customers.customers.contracts.edit', {
                customer: contract.customer_id,
                contract: contract.id
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    a {
        color: inherit;

        &:hover {
            text-decoration: none;
        }
    }
</style>
<style lang="scss">
    .contact-list-dropdown .d-dropdown {
        z-index: 1060 !important;
    }
</style>
